import { Popover, PopoverContent, PopoverTrigger } from "@/components/ui/popover";
import { HelpCircle } from "lucide-react";
import { Link } from "react-router-dom";

/**
 * ContextualHelp — a small "?" icon next to complex controls. Clicking
 * pops a short explanation + optional "Watch tutorial" link. Designed to
 * be subtle — never blocks interaction with the underlying control.
 */
export default function ContextualHelp({
  title,
  body,
  tutorialSlug,
  className = "",
  testid,
}) {
  return (
    <Popover>
      <PopoverTrigger asChild>
        <button
          type="button"
          className={`inline-flex items-center justify-center w-5 h-5 rounded-full text-tbc-gold/70 hover:text-tbc-gold ${className}`}
          aria-label={`Help: ${title}`}
          data-testid={testid || "contextual-help-btn"}
        >
          <HelpCircle className="w-4 h-4" />
        </button>
      </PopoverTrigger>
      <PopoverContent className="w-72 text-sm" side="top" align="start">
        <p className="font-heading text-tbc-navy text-sm mb-1">{title}</p>
        <p className="text-gray-600 text-xs leading-relaxed mb-2">{body}</p>
        <Link
          to={tutorialSlug ? `/business-academy?tutorial=${tutorialSlug}` : "/business-academy"}
          className="text-tbc-gold text-xs font-heading hover:underline"
        >
          Learn more in Business Academy →
        </Link>
      </PopoverContent>
    </Popover>
  );
}
